// extracted by mini-css-extract-plugin
export default {"profileEdit":"edit_profileEdit__Q1jju"};